import { createSvgIcon } from "@mui/material";

export const ArrowRightIcon = createSvgIcon(
  <svg fill="none">
    <path d="M10 17L15 12L10 7V17Z" fill="currentColor" />
  </svg>,
  "ArrowRightIcon",
);
